export enum ButtonStatus {
	SUCCESS = "SUCCESS",
	ACTION = "ACTION",
}

export enum ButtonColor {
	BRAND = "BRAND",
	ACTION = "ACTION",
	ACTION_SECONDARY = "ACTION_SECONDARY",
	/**
	 * Soft/tinted action: brand-coloured label on a light brand wash, no visible border. The
	 * "secondary but still branded" control used for opt-in affordances that sit beside filters
	 * rather than competing with the row's primary button (e.g. "Pin to tab", PREC-3880).
	 */
	ACTION_SOFT = "ACTION_SOFT",
	DANGER = "DANGER",
	ERROR = "error",
	DANGER_SECONDARY = "DANGER_SECONDARY",
	WARNING = "WARNING",
	SUCCESS = "SUCCESS",
	DISABLED = "DISABLED",
}

export enum ButtonSize {
	XS = "XS",
	S = "S",
	M = "M",
	ML = "ML",
	L = "L",
}

export enum FontSize {
	XS = "XS",
	SM = "SM",
}
